import api from "./api";

let sessionId = null;
function getSessionId() {
  if (sessionId) return sessionId;
  let sid = sessionStorage.getItem("a_sid");
  if (!sid) {
    sid = `sid_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem("a_sid", sid);
  }
  sessionId = sid;
  return sid;
}

export async function track(eventType, { campaignId, leadId, payload } = {}) {
  try {
    await api.post("/analytics/event", {
      event_type: eventType,
      campaign_id: campaignId || null,
      lead_id: leadId || null,
      session_id: getSessionId(),
      payload: payload || {},
    });
  } catch (err) {
    // Silent in prod — analytics is best-effort. Log in dev for visibility.
    if (process.env.NODE_ENV !== "production") {
      console.warn("analytics.track failed:", eventType, err?.message);
    }
  }
}

// Scroll depth tracker (returns cleanup)
export function trackScrollDepth(campaignId) {
  const buckets = [25, 50, 75, 90];
  const fired = new Set();

  const handler = () => {
    const scrolled = window.scrollY + window.innerHeight;
    const total = document.documentElement.scrollHeight;
    const pct = Math.min(100, Math.round((scrolled / total) * 100));
    buckets.forEach((b) => {
      if (pct >= b && !fired.has(b)) {
        fired.add(b);
        track("scroll_depth", { campaignId, payload: { depth: b } });
      }
    });
  };

  window.addEventListener("scroll", handler, { passive: true });
  return () => window.removeEventListener("scroll", handler);
}

// Section dwell-time using IntersectionObserver
export function trackSectionDwell(campaignId) {
  const sections = document.querySelectorAll("[data-section]");
  if (!sections.length) return () => {};
  const enterTimes = new WeakMap();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute("data-section");
        if (entry.isIntersecting) {
          enterTimes.set(entry.target, Date.now());
        } else if (enterTimes.has(entry.target)) {
          const ms = Date.now() - enterTimes.get(entry.target);
          enterTimes.delete(entry.target);
          if (ms > 500) {
            track("section_dwell", {
              campaignId,
              payload: { section: id, ms },
            });
          }
        }
      });
    },
    { threshold: 0.4 }
  );

  sections.forEach((s) => observer.observe(s));
  return () => observer.disconnect();
}
